const part = [
    {
        path: 'company-management',
        name: 'company-management',
        meta: {
            icon: 'md-people',
            title: '公司管理',
            notCache: true,
            access: ['S'],
            items: []
        },
        component: () => import('@/view/system-management/company-management/company-list.vue')
    }
];

export default part;
